import { __awaiter, __generator } from 'tslib';
import Vue from 'vue';
import { magic } from '@gig/magic-sdk';

var _a;
var OFFER_NAMESPACE = 'OFFER_NAMESPACE';
var SET_OFFER = 'SET_OFFER';
var SET_OFFERS = 'SET_OFFERS';
var offerGetters = {
    getOffer: function (state) {
        return function (offerSlug, lang) {
            var offer = state.offers[lang] && state.offers[lang][offerSlug];
            if (!offer) {
                return null;
            }
            return offer;
        };
    },
    getOffersByAffiliate: function (state) {
        return function (offerSlugPrefix, affiliateId, lang) {
            var allOffers = state.offers[lang];
            if (!allOffers) {
                return [];
            }
            var offers = Object.values(allOffers);
            var matchedOffers = offers.filter(function (offer) {
                return offer.slug.startsWith(offerSlugPrefix) &&
                    offer.btag === affiliateId;
            });
            if (affiliateId && matchedOffers.length === 0) {
                matchedOffers = offers.filter(function (offer) { return offer.slug === offerSlugPrefix; });
            }
            return matchedOffers;
        };
    },
};
var offerActions = {
    fetchOffer: function (_a, _b) {
        var commit = _a.commit, getters = _a.getters;
        var slug = _b.slug, lang = _b.lang;
        return __awaiter(this, void 0, void 0, function () {
            var offer, fetchedOffer;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        offer = getters.getOffer(slug, lang);
                        if (offer) {
                            return [2 /*return*/, offer];
                        }
                        return [4 /*yield*/, magic.methods.offers.get(lang, slug)];
                    case 1:
                        fetchedOffer = _c.sent();
                        commit(SET_OFFER, { offer: fetchedOffer, lang: lang });
                        return [2 /*return*/, fetchedOffer];
                }
            });
        });
    },
    fetchAllOffers: function (_a, _b) {
        var commit = _a.commit;
        var lang = _b.lang;
        return __awaiter(this, void 0, void 0, function () {
            var allOffers;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, magic.methods.offers.getAll(lang)];
                    case 1:
                        allOffers = _c.sent();
                        if (!allOffers) {
                            return [2 /*return*/, null];
                        }
                        commit(SET_OFFERS, { allOffers: allOffers, lang: lang });
                        return [2 /*return*/, allOffers];
                }
            });
        });
    },
};
var offers = {
    namespaced: true,
    state: {
        offers: {},
    },
    getters: offerGetters,
    actions: offerActions,
    mutations: (_a = {},
        _a[SET_OFFER] = function (state, _a) {
            var _b;
            var lang = _a.lang, offer = _a.offer;
            if (!state.offers[lang]) {
                Vue.set(state.offers, lang, (_b = {}, _b[offer.slug] = offer, _b));
                return;
            }
            Vue.set(state.offers[lang], offer.slug, offer);
        },
        _a[SET_OFFERS] = function (state, _a) {
            var allOffers = _a.allOffers, lang = _a.lang;
            var offerDictionary = allOffers.reduce(function (prev, offer) {
                prev[offer.slug] = offer;
                return prev;
            }, {});
            Vue.set(state.offers, lang, offerDictionary);
        },
        _a),
};

export { OFFER_NAMESPACE, offerActions, offerGetters, offers };
